import { addDomainOnUrl } from '../../Utils/functionnals'
import { composeOfferUrl } from '../../Utils/offers/offerUrl'
import { OfferTeaserProps } from '../offers'
import type { AlgoliaSearchResult } from './resultMapper'

export type OfferAlgoliaSearchResult = {
  title: string
  payRange?: {
    min?: number
    max?: number
  }
  url: string
  firm: {
    slug: string
    name: string
    logo: {
      url?: string
      formats?: {
        thumbnail?: string
      }
    } | null
    header?: {
      url: string
      formats: {
        small: string
        medium: string
        thumbnail: string
        large: string
      }
    }
  }
  office: {
    name: string
    city: string
    postalCode: string
  }
  contractType?: string
  slug: string
  startDate?: string
  _geoloc: {
    lat: number
    lng: number
  }
}

export const OfferTeaserMapper = (
  searchResult: AlgoliaSearchResult<OfferAlgoliaSearchResult>,
): OfferTeaserProps => {
  const min =
    typeof searchResult.hit.payRange?.min === 'string'
      ? parseInt(searchResult.hit.payRange?.min, 10)
      : searchResult.hit.payRange?.min
  const max =
    typeof searchResult.hit.payRange?.max === 'string'
      ? parseInt(searchResult.hit.payRange?.max, 10)
      : searchResult.hit.payRange?.max

  const logoUrl = addDomainOnUrl(searchResult.hit.firm.logo?.url)
  const headerImageUrl = addDomainOnUrl(
    searchResult.hit.firm.header?.formats?.small,
  )
  const city = searchResult.hit.office.city ? searchResult.hit.office.city : ''
  const cityCut = city.length > 18 ? `${city.slice(0, 18)}...` : city

  return {
    title: searchResult.hit.title,
    companyName: searchResult.hit.firm.name,
    contractType: searchResult.hit.contractType,
    logo: logoUrl,
    url: composeOfferUrl({
      firmSlug: searchResult.hit.firm.slug,
      offerSlug: searchResult.hit.slug,
      url: searchResult.hit.url,
    }),
    city: `${cityCut} ${
      searchResult.hit.office.postalCode
        ? `(${searchResult.hit.office.postalCode.slice(0, 2)})`
        : ''
    }`,
    headerImage: headerImageUrl,
    salary: {
      min,
      max,
    },
    startDate: searchResult.hit.startDate
      ? new Date(searchResult.hit.startDate)
      : 'Dès que possible',
  }
}
